import React from 'react';

import { Flex, Switch, Typography } from 'antd';

interface IWebhookPayloadToggleProps {
  payloadKey: string;
  checked: boolean;
  onChange: (key: string, value: boolean) => void;
  disabled?: boolean;
}

export const WebhookPayloadToggle = ({
  payloadKey,
  checked,
  onChange,
  disabled = false,
}: IWebhookPayloadToggleProps) => (
  <Flex justify="space-between" align="center" style={{ padding: '2px 0' }}>
    <Typography.Text
      type="secondary"
      role="button"
      tabIndex={0}
      onClick={() => {
        if (!disabled) onChange(payloadKey, !checked);
      }}
      onKeyDown={(e) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' '))
          onChange(payloadKey, !checked);
      }}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        marginBottom: 0,
        fontWeight: checked ? 'bold' : 'normal',
      }}
    >
      {payloadKey}
    </Typography.Text>
    <Switch
      checked={checked}
      onChange={(val) => onChange(payloadKey, val)}
      disabled={disabled}
      data-testid={`webhook-payload-${payloadKey}-toggle`}
    />
  </Flex>
);
